import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet'; // Using react-helmet as per your setup
import { useParams, Link } from 'react-router-dom';
import Apiservice from '../services/Apiservice';
import Navigationbar from '../components/Navigationbar';
import Footer from '../components/Footer';
import CommonFunctions from '../components/CommonFunctions';

const PostDetailComponent = () => {
  const [post, setPost] = useState(null);
  const [postTitle, setPostTitle] = useState('');
  const { id } = useParams();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const postId = id;
        const response = await Apiservice.getBlogPostsById(postId);
        setPost(response.data);
        setPostTitle(response.data.title);
      } catch (error) {
        console.error('Error fetching post:', error);
      }
    };

    fetchPost();
  }, [id]);

  const getShortDescription = (content) => {
    if (!content) return "Latest cricket news and updates.";
    const strippedContent = content.replace(/<[^>]+>/g, '');
    return strippedContent.length > 150
      ? `${strippedContent.substring(0, 150)}...`
      : strippedContent;
  };

  // Split tags into an array if post exists
  const tagsArray = post && post.tags ? post.tags.split(',') : [];

  const pageTitle = post
    ? `${post.title} | ${post.tournament_type === null ? 'WPL' : post.tournament_type} News | WPL Cricinfo`
    : 'Loading... | WPL 2025 News | WPL Cricinfo';
  const description = post ? getShortDescription(post.content) : 'Loading the latest cricket news post.';
  const keywords = post
    ? `WPL 2025, ${post.tournament_type || 'WPL'}, ${post.title}, cricket news, ${post.tags || ''}`
    : 'WPL 2025, cricket news';
  const ogTitle = post ? post.title : 'Loading...';
  const ogImage = post ? `https://wplcricinfo.com/wpl/admin/${post.imgUrl}` : '';

  return (
    <React.Fragment>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={description} />
        {ogImage && <meta property="og:image" content={ogImage} />}
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="bg-fluid"></div>
      <Navigationbar />
      <div className="container-fluid">
        <nav aria-label="breadcrumb" className="">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/" className="text-muted text-decoration-none">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/wpl-news-updates" className="text-muted text-decoration-none">WPL News & Updates</Link>
            </li>
            <li className="breadcrumb-item text-white active" aria-current="page">
              {postTitle || 'Loading...'}
            </li>
          </ol>
        </nav>
        <div className="row">
          <div className="col-md-12">
            {post ? (
              <div className="card">
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src={`https://wplcricinfo.com/wpl/admin/${post.imgUrl}`}
                      alt={post.title || 'Post'}
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <small className="text-muted">{CommonFunctions.getPostDateFormat(post.created_at)}</small>
                      <h2 className="card-title fs-5 fw-bold">{post.title}</h2>
                      <div dangerouslySetInnerHTML={{ __html: post.content }}></div>
                    </div>
                    <div className="card-footer">
                      <div className="mb-2">Tags:</div>
                      {tagsArray.length > 0 ? (
                        tagsArray.map((tag, index) => (
                          <span key={index} className="badge bg-primary me-1 mb-1">
                            {tag.trim()}
                          </span>
                        ))
                      ) : (
                        <span>No tags</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default PostDetailComponent;